import { Condition, QueryPageResult, RuntimeModel, http } from '@kunlun/dependencies';
import { stringifyToGraphql } from '../../../../utils/serialize';

export interface ProductList {
  id: string;
  code: string;
  outCode: string;
  name: string;
  itemNumber: string;
  priceType: string;
  itemCalc: string;
}

export const queryAddProductList = async (
  rModel: RuntimeModel,
  page: { currentPage: number; size: number },
  params: { code?: string; outCode?: string; name?: string; itemNumber?: string; priceType?: string | null }
) => {
  const condition = new Condition('(1==1)');
  for (const [key, value] of Object.entries(params)) {
    if (!value) continue;
    const cond = new Condition(key);
    if (['priceType'].includes(key)) {
      cond.equal(value);
      condition.and(cond);
    } else {
      cond.like(value);
      condition.and(cond);
    }
  }

  const gql = `
  query {
    deliAriesActivityItemTplDetailQuery {
      queryPage(
        page: ${stringifyToGraphql(page)}
        queryWrapper: {
          rsql: "${condition.toString()}"
          queryData: {
            ${params.code ? `code: "${params.code}"` : ''}
            ${params.outCode ? `outCode: "${params.outCode}"` : ''}
            ${params.name ? `name: "${params.name}"` : ''}
            ${params.itemNumber ? `itemNumber: "${params.itemNumber}"` : ''}
            ${params.priceType ? `priceType: ${params.priceType}` : ''}
          }
        }
      ) {
        content {
          id
          code
          outCode
          name
          itemNumber
          priceType
          itemCalc
        }
        totalPages
        totalElements
      }
    }
  }  
  `;

  const res = await http.query<QueryPageResult<ProductList>>(rModel.moduleName, gql);
  return res.data.deliAriesActivityItemTplDetailQuery.queryPage;
};
